import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import { apiConstants, duckConstants } from '../constants';
import { DuckProvider } from '../myduck';
import { reducer } from './ducks';

const LiveCodeInterviewSetup = lazy(() => import('./containers/liveCodeInterviewSetup'));
const LiveMonitoring = lazy(() => import('./containers/liveMonitoring'));
const LiveAccessCheck = lazy(() => import('./containers/liveAccessCheck'));

const LiveCodeAdminContainer = ({ history }) => {
  return (
    /* BEWARE: admin = true IS NOT USE FOR AUTHENTICATE OR ANYTHING, JUST USE TO SWITCH TO ADMIN REDUCER */
    <DuckProvider reducer={reducer} reducerRoot={duckConstants.LCI_SETUP_ROOT} history={history}>
      <Switch>
        <Route exact path={apiConstants.LIVE_CODE_SETUP} component={LiveCodeInterviewSetup} />
        <Route exact path={apiConstants.LIVE_CODE_ACCESS_ADMIN} component={LiveAccessCheck} />
        <Route exact path={`${apiConstants.LIVE_CODE_ACCESS_ADMIN}/:code`} component={LiveAccessCheck} />
        <Route exact path={apiConstants.LIVE_CODE_MONITORING} component={LiveMonitoring} />
        <Redirect to={apiConstants.ADMIN_LOGIN} />
      </Switch>
    </DuckProvider>
  );
};

LiveCodeAdminContainer.propTypes = {
  history: PropTypes.object
};

export default LiveCodeAdminContainer;
